import { STRINGS } from "../../strings";
import { translate } from "../../translate";

export interface PdfDocumentType {
  title: string;
  type: string;
}

// Should be exported to server
const postingRequirementsDocuments: { title: string; type: string; pdfUrl: string }[] = [
  {
    title: "Veterans’ Benefits & Services",
    type: "VeteransBenefitsAndServices",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/veterans-benefits-and-services.pdf",
  },
  {
    title: "Retaliatory action by employers; prohibition",
    type: "RetaliatoryActionByEmployersProhibition",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/retaliatory.pdf",
  },
  {
    title: "Construction Industry Fair Play Act",
    type: "ConstructionIndustryFairPlayAct",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/construction-industry-fair-play-act.pdf",
  },
  {
    title: "Criminal Convictions Records",
    type: "CriminalConvictionsRecords",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/criminal_convictions_records.pdf",
  },
  {
    title: "Discrimination",
    type: "Discrimination",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/discrimination.pdf",
  },
  {
    title: "Minimum Wage - Home Care Aide",
    type: "MinimumWageHomeCareAide",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/home_care_aide_2023.pdf",
  },
  {
    title: "Minimum Wage - New York State Department of Labor",
    type: "MinimumWageNewYorkStateDepartmentOfLabor",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/minimum_wage_2023.pdf",
  },
  {
    title: "Safety & Health",
    type: "SafetyAndHealth",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/safety_and_health.pdf",
  },
  {
    title: "Public Work / Prevailing Wage Rates",
    type: "PublicWorkPrevailingWageRates",
    pdfUrl: "",
  },
  {
    title: "Public Work Project",
    type: "PublicWorkProject",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/public-work-project.pdf",
  },
  {
    title: "Unemployment Insurance",
    type: "UnemploymentInsurance",
    pdfUrl: "",
  },
  {
    title: "Workers' Compensation and Disability Benefits",
    type: "WorkersCompensationAndDisabilityBenefits",
    pdfUrl: "",
  },
  {
    title: "Smoking",
    type: "Smoking",
    pdfUrl: "",
  },
  {
    title: "Mandatory Nurse Overtime",
    type: "MandatoryNurseOvertime",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/mandatory-nurse-overtime.pdf",
  },
  {
    title: "Fringe Benefits and Hours",
    type: "FringeBenefitsAndHours",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/fringe-benefits-and-hours.pdf",
  },
  {
    title:
      "Guidelines Regarding the Rights of Nursing Mothers to Express Breast Milk in the Work Place",
    type: "GuidelinesRegardingTheRightsOfNursingMothers",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/guidelines-regarding-the-rights-of-nursing-mothers.pdf",
  },
  {
    title: "Equal Pay",
    type: "EqualPay",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/equal-pay.pdf",
  },
  {
    title: "Sexual Harassment",
    type: "SexualHarassment",
    pdfUrl: "",
  },
  {
    title: "Notice Of Pay",
    type: "NoticeOfPay",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/notice-of-pay.pdf",
  },
  {
    title: "Posting of Hours for Minors",
    type: "PostingOfHoursForMinors",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/posting-of-hours-for-minors.pdf",
  },
  {
    title: "Minimum Wage - Federal",
    type: "MinimumWageFederal",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/minimum-wage-poster.pdf",
  },
  {
    title: "Job Saftey and Health: It's the Law",
    type: "JobSafteyAndHealthItsTheLaw",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/job-safety-and-health-poster.pdf",
  },
  {
    title: "Employee Rights and Responsibilities Under The Family and Medical Leave Act",
    type: "EmployeeRightsAndResponsibilitiesUnderTheFamily",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/employee-rights-poster.pdf",
  },
  {
    title: "Know Your Rights",
    type: "KnowYourRights",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/know-your-rights-poster.pdf",
  },
  {
    title: "Pay Transparency Nondiscrimination Provision",
    type: "PayTransparencyNondiscriminationProvision",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/pay-transparency-poster.pdf",
  },
  {
    title: "Your Rights Under USERRA",
    type: "YourRightsUnderUSERRA",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/your-rights-under-userra-poster.pdf",
  },
  {
    title: "Employee Rights Under The H-2A Program",
    type: "EmployeeRightsUnderTheH2AProgram",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/employee-rights-under-the-h2a-poster.pdf",
  },
  {
    title: "Employee Right for Workers with Disabilities/Special Minimum Wage Poster",
    type: "EmployeeRightForWorkersWithDisabilities",
    pdfUrl:
      "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/importantinformation/employee-rights-for-workers-with-disabilities-poster.pdf",
  },
];

export const postingRequirementsTypes: { type: string; title: string }[] = [
  {
    title: "Veterans’ Benefits & Services",
    type: "VeteransBenefitsAndServices",
  },
  {
    title: "Retaliatory action by employers; prohibition",
    type: "RetaliatoryActionByEmployersProhibition",
  },
  {
    title: "Construction Industry Fair Play Act",
    type: "ConstructionIndustryFairPlayAct",
  },
  {
    title: "Criminal Convictions Records",
    type: "CriminalConvictionsRecords",
  },
  {
    title: "Discrimination",
    type: "Discrimination",
  },
  {
    title: "Minimum Wage - Home Care Aide",
    type: "MinimumWageHomeCareAide",
  },
  {
    title: "Minimum Wage - New York State Department of Labor",
    type: "MinimumWageNewYorkStateDepartmentOfLabor",
  },
  {
    title: "Safety & Health",
    type: "SafetyAndHealth",
  },
  {
    title: "Public Work / Prevailing Wage Rates",
    type: "PublicWorkPrevailingWageRates",
  },
  {
    title: "Public Work Project",
    type: "PublicWorkProject",
  },
  {
    title: "Unemployment Insurance",
    type: "UnemploymentInsurance",
  },
  {
    title: "Workers' Compensation and Disability Benefits",
    type: "WorkersCompensationAndDisabilityBenefits",
  },
  {
    title: "Smoking",
    type: "Smoking",
  },
  {
    title: "Mandatory Nurse Overtime",
    type: "MandatoryNurseOvertime",
  },
  {
    title: "Fringe Benefits and Hours",
    type: "FringeBenefitsAndHours",
  },
  {
    title:
      "Guidelines Regarding the Rights of Nursing Mothers to Express Breast Milk in the Work Place",
    type: "GuidelinesRegardingTheRightsOfNursingMothers",
  },
  {
    title: "Equal Pay",
    type: "EqualPay",
  },
  {
    title: "Sexual Harassment",
    type: "SexualHarassment",
  },
  {
    title: "Notice of Pay",
    type: "NoticeOfPay",
  },
  {
    title: "Posting of Hours for Minors",
    type: "PostingOfHoursForMinors",
  },
  {
    title: "Minimum Wage - Federal",
    type: "MinimumWageFederal",
  },
  {
    title: "Job Saftey and Health: It's the Law",
    type: "JobSafteyAndHealthItsTheLaw",
  },
  {
    title: "Employee Rights and Responsibilities Under The Family and Medical Leave Act",
    type: "EmployeeRightsAndResponsibilitiesUnderTheFamily",
  },
  {
    title: "Know Your Rights",
    type: "KnowYourRights",
  },
  {
    title: "Pay Transparency Nondiscrimination Provision",
    type: "PayTransparencyNondiscriminationProvision",
  },
  {
    title: "Your Rights Under USERRA",
    type: "YourRightsUnderUSERRA",
  },
  {
    title: "Employee Rights Under The H-2A Program",
    type: "EmployeeRightsUnderTheH2AProgram",
  },
  {
    title: "Employee Right for Workers with Disabilities/Special Minimum Wage Poster",
    type: "EmployeeRightForWorkersWithDisabilities",
  },
];

// Should be exported to server
const agencyHandbook = {
  title: translate(STRINGS.MEDFLYT_AGENCY_HANDBOOK),
  type: "MedflytAgencyHandbook",
  imagePreview:
    "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/agencyhandbook/handbook_preview.jpg",
  pdfUrl:
    "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/agencyhandbook/employee_handbook.pdf",
};

const agencyBenefits = {
  title: translate(STRINGS.MEDFLYT_AT_HOME_BENEFITS),
  type: "MedflytAgencyBenefits",
  imagePreview:
    "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/agencyBenefits/Medflyt_benefits.png",
  pdfUrl:
    "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/agencyBenefits/medflyt_at_home_benefits.pdf",
};

const MECWaiverInformation = {
  title: translate(STRINGS.MEC_WAIVER_INFORMATION),
  type: "MECWaiverInformation",
  imagePreview:
    "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/MECWaiver/MEC_preview.png",
  pdfUrl:
    "https://medflyt-mobile-assets.s3.amazonaws.com/mobile-assets/MECWaiver/medflyt_at_home_MEC_2023.pdf",
};

const mappedPostingRequirements = postingRequirementsDocuments.map((req) => ({
  ...req,
  imagePreview: req.pdfUrl.replace(".pdf", "_header.png"),
}));

// Should  be exported to server
export const pdfDocuments = [
  ...mappedPostingRequirements,
  agencyHandbook,
  agencyBenefits,
  MECWaiverInformation,
];
